module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "warp"
  }, [_c('div', {
    staticClass: "head_warps",
    style: ({
      height: _vm.wheight + 'rem'
    })
  }, [_c('img', {
    staticClass: "head_img",
    style: ({
      height: _vm.imgheight
    }),
    attrs: {
      "src": _vm.headmsg.memberBackgroundImg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "head_wrap",
    style: ({
      top: _vm.top + 'rem'
    })
  }, [_c('div', {
    staticClass: "Head_portrait",
    style: ({
      width: _vm.width + 'rem',
      height: _vm.height + 'rem',
      border: _vm.border + 'rem solid #fff'
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.headmsg.memberSmallImg || require('../static/images/share_1.png')
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "introduce"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.headmsg.memberPetName || '比笔'))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.headmsg.signInfo || '暂未留下签名'))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "follow_num"
  }, [_vm._v("关注" + _vm._s(_vm.headmsg.myFollowCount || '0'))]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    staticClass: "fans_num"
  }, [_vm._v("粉丝" + _vm._s(_vm.headmsg.fansCount || '0'))])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_all"
  }, [_vm._v("全部文章 " + _vm._s(_vm.headmsg.memberInfoCount || '0'))])]), _vm._v(" "), _c('div', {
    staticClass: "main",
    style: ({
      top: _vm.mtop + 'rem'
    })
  }, [_c('div', {
    ref: "main",
    attrs: {
      "id": "main"
    }
  }, _vm._l((_vm.listmsg), function(list) {
    return _c('div', {
      key: list.hits,
      attrs: {
        "customInfoId": list.customInfoId
      }
    }, [_c('List', {
      attrs: {
        "listmsg": list
      }
    })], 1)
  }), 0), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    attrs: {
      "on-infinite": _vm.onInfinite,
      "spinner": "bubbles"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("没有更多内容啦")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d72e3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 71
// module chunks = 1